interface FormValidationDetail {
    formClass?: string | null;
    formName?: string | null;
}

/**
 * Toggles the 'required' attribute on target inputs and adds 'required'
 * to the parent wrappers.
 *
 * @param checkbox - The checkbox that was changed
 */
const toggleRequiredFields = (checkbox: HTMLInputElement): void => {
    const targetIds = checkbox.dataset.jsTargetIds;
    if (!targetIds) return;

    // Split IDs (supports comma-separated list: "id1, id2, id3")
    const ids: string[] = targetIds.split(',').map((id: string): string => id.trim());

    // For each target ID, find the field and update it
    ids.forEach((id: string): void => {
        const inputField: HTMLInputElement | null = document.getElementById(id) as HTMLInputElement;

        if (!inputField) return;

        const form : HTMLFormElement | null = inputField.closest('form') as HTMLFormElement;

        if (!form) return;

        // The behavior depends on the checkbox's checked state
        const shouldBeRequired: boolean = checkbox.checked;

        // Set/remove the 'required' attribute on the input itself
        if (shouldBeRequired) {
            inputField.setAttribute('required', 'required');
            inputField.removeAttribute('data-ignore');
        } else {
            inputField.removeAttribute('required');
            inputField.setAttribute('data-ignore', 'true');
        }

        // Find the nearest parent element with class 'js-form-wrap'
        // and add/remove 'required' class there as well
        const formWrap: HTMLElement | null = inputField.closest('.js-form-wrap');
        if (formWrap) {
            if (shouldBeRequired) {
                formWrap.classList.add('required');
            } else {
                formWrap.classList.remove('required');
            }
        }

        document.body.dispatchEvent(
            new CustomEvent<FormValidationDetail>('formValidation:revalidate', {
                bubbles: true,
                detail: {
                    formName: form.getAttribute('name')
                },
            })
        );

        // revalidate only checks for empty values, run full field validation (e.g. birthday min/max)
        if (inputField.value || !shouldBeRequired) {
            inputField.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
};

/**
 * Initializes the logic for conditional required fields.
 * Should be called once when the DOM is ready.
 */
const init = (): void => {
    // Event delegation: We listen to the 'change' event on the entire document.
    document.addEventListener('change', (ev: Event): void => {
        const target = ev.target;

        // Check if the element that triggered the change is a toggle checkbox
        if (
        target instanceof HTMLInputElement &&
        target.matches('.js-form-toggle-required') &&
        target.type === 'checkbox'
        ) {
            toggleRequiredFields(target);
        }
    });
};

export { init };
